var link_viewer_default = {
  "fontElementMap": "CrvH-",
  "link": "-fg1x",
  "linkInEditor": "ox5KU",
  "linkInViewer": "hSmSt",
  "toolbarUrlContainer": "LLse9",
  "toolbarUrl": "hJLqq",
  "toolbarUrlAnchor": "Tx2d1"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
